import React, {useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {GeneralDataOFLoginUser} from '../../../../../Utils/Auth'
import {getAllAccountManagerList, getAllSalesList} from '../../UserListSlice/UserListSlice'
import {UpdateAssigneTo} from '../UserProfileDetailSlice/UserProfileDetailSlice'
import Select from 'react-select'
import {ASSIGN_STAFF_STATUS} from '../../../../../Utils/Constant/status'

const ChangeAssignedStaff = ({show, handleClose, list, setAssign}: any) => {
  const param: any = useLocation()
  const dispatch = useDispatch()
  const [searchName, setSearchName] = useState('')

  const accountManagerlist = useSelector(getAllAccountManagerList)
  const sales = useSelector(getAllSalesList)
  const Role = GeneralDataOFLoginUser()?.role

  const handleChange = (e: any, {name}: any) => {
    setAssign({...list, [name]: e.value})
  }

  const handleSubmit = () => {
    const status = Role == 'superAdmin' ? {status: ASSIGN_STAFF_STATUS.APPROVED} : {}

    dispatch(UpdateAssigneTo({...list, ...status}))
    handleClose()
  }

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-600px'
        className='vh-100 '
        size='sm'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header'>
          {Role == 'superAdmin' ? <h2>Assign Staff</h2> : <h2>Request Assign Staff</h2>}
        </div>
        <div className='modal-body p-12'>
          <div className='col'>
            <label className=' col-form-label  fw-bold fs-6'>Account Manager</label>

            <div className='row'>
              <div className='col fv-row'>
                <Select
                  name='accountManagerId'
                  options={
                    accountManagerlist?.map((key: any) => ({
                      value: key?._id,
                      label: key?.name,
                    })) || []
                  }
                  onChange={handleChange}
                  value={
                    list?.accountManagerId !== ''
                      ? {
                          value: list?.accountManagerId,
                          label: accountManagerlist?.find(
                            (key: any) => key?._id === list?.accountManagerId
                          )?.name,
                        }
                      : {value: '', label: 'Select Account Manager'}
                  }
                />
                {/* <select
                  value={list?.accountManagerId}
                  className='form-select form-select-solid form-select-lg'
                >
                  <option>select</option>
                  {accountManagerlist?.map((key: any) => (
                    <option key={key?._id} value={key?._id}>
                      {key?.name}
                    </option>
                  ))}
                </select> */}
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block text-danger'></div>
                </div>
              </div>
            </div>
          </div>
          <div className='col'>
            <label className=' col-form-label  fw-bold fs-6'>Sales</label>

            <div className='row'>
              <div className='col fv-row'>
                <Select
                  name='salesId'
                  options={
                    sales?.map((key: any) => ({
                      value: key?._id,
                      label: key?.name,
                    })) || []
                  }
                  // onInputChange={() => setSearchName(e)}
                  onChange={handleChange}
                  value={
                    list?.salesId !== ''
                      ? {
                          value: list?.salesId,
                          label: sales?.find((key: any) => key?._id === list?.salesId)?.name,
                        }
                      : {value: '', label: 'Select Account Manager'}
                  }
                />
                {/* <select
                  value={list?.salesId}
                  name='salesId'
                  onChange={handleChange}
                  className='form-select form-select-solid form-select-lg'
                >
                  <option>select</option>
                  {sales?.map((key: any) => (
                    <option key={key?._id} value={key?._id}>
                      {key?.name}
                    </option>
                  ))}
                </select> */}
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block text-danger'></div>
                </div>
              </div>
            </div>
          </div>

          <div className='d-flex flex-center mt-5'>
            <div id='kt_drawer_chat_close'>
              <button
                type='button'
                onClick={() => {
                  handleClose()
                  setAssign({
                    ...list,
                    accountManagerId: '',
                    salesId: '',
                  })
                }}
                className='btn btn-sm btn-light text-hover-white bg-white btn-active-primary text-primary me-2 w-100px p-3 fw-500 me-2'
              >
                Cancel
              </button>
            </div>

            <button
              type='submit'
              className='btn btn-sm btn-light btn-primary fw-500   w-100px p-3 border border-primary'
              onClick={handleSubmit}
            >
              <span className='indicator-label'>Submit</span>
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ChangeAssignedStaff
